export const FETCH_QUEUE_APPLICATIONS_REQUEST =
  'FETCH_QUEUE_APPLICATIONS_REQUEST'
export const FETCH_QUEUE_APPLICATIONS_SUCCESS =
  'FETCH_QUEUE_APPLICATIONS_SUCCESS'
export const FETCH_QUEUE_APPLICATIONS_FAILURE =
  'FETCH_QUEUE_APPLICATIONS_FAILURE'
export const FETCH_QUEUE_APPLICATIONS_CLEANUP =
  'FETCH_QUEUE_APPLICATIONS_CLEANUP'
